<nav class="navbar navbar-toggleable-md navbar-expand-lg navbar-light fixed-top" data-spy="scroll" data-target="#navbarSupportedContent">

  <div class="navbar-header" id="navbar-header">
    <a class="navbar-brand m-0 p-0" id="navbar-brand" href="#" style="display: inline-block">
      <img src="../assets/img/logo-1.png" alt="" class="logo ml-4" height="50">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </a>
    <button class="navbar-toggler mr-auto" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="true" aria-label="Toggle navigation">
      <fa-icon [icon]="faBars"></fa-icon>
    </button>
  </div>
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav ml-auto">
      <li class="nav-item active" data-toggle="collapse" data-target=".navbar-collapse.show">
        <a class="nav-link" href="#home">Home</a>
      </li>&nbsp;&nbsp;
      <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
        <a class="nav-link" href="#about">About Me</a>
      </li>&nbsp;&nbsp;
      <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
        <a class="nav-link" href="#skills">Skills</a>
      </li>&nbsp;&nbsp;
      <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
        <a class="nav-link" href="#experience">Experience</a>
      </li>&nbsp;&nbsp;
      <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
        <a type="button" class="nav-link" href="#contact">Contact</a>
      </li>
    </ul>
  </div>
</nav>

<div class="container">
  <div class="row parallax" data-parallax="scroll" data-image-src="../assets/img/banner-6.png" id="home">
    <div class="card-3 m-auto p-2 auroral-northern animate__animated animate__zoomIn text-center">
      <h4>Hello world. I am</h4>
      <h1 class="note text-center">EXTENSION <b class="logo">TLHARESENG</b></h1>
      <h4>UI/UX Designer/Software Developer & Entrepreneur</h4>
    </div>
  </div>
  <div class="row" id="about">
    <div class="container-2 mx-auto p-4">
      <div class="intro">
        <h1 class="welcome">About Me</h1>
        <p>
          I am very passionate about technology and extremely intrigued by its impact on the world today and the future
           of our civilization, seeing what we can do with it. I have gained valuable experience as a software developer,
           using modern cutting-edge technologies while constantly adhering to and getting up-to-date with the industry standards.
           Front-End development is one of my strengths as a UI/UX designer and application architect with an eye for detail. My knowledge 
           of The Design Tools and Front-End scripting languages, libraries and frameworks and the SDLC enables me to deliver quality work effiiently and be able to
           complete my tasks on time following the agile methodology. <br><br>

           Working in great teams and peer collaborations has gained me the knowledge of Back-End development and technologies putting
            more muscle on my skill set as a developer and a professional. My ability to work well under pressure has been through learning 
            new tech while working on delivering great and efficient REST-APIs and also integrating third-party APIs working with CORS. Back-End development
            has exposed me to database design  and the DBMS technologies making me a well rounded developer. My skill set has found me working in great and diverse teams
            of extremely talented individuals building responsive, mobile-optimized web applications and hybrid mobile apps. Seeing that this is a very wide
            industry I have interest in Artificial Intelligence and Machine Learning. I always look forward to working on challenging projects
            and very well out of the comfort of my skill set.
        </p>
      </div>
    </div>
  </div>
  <div class="row parallax" data-parallax="scroll" data-image-src="../assets/img/spacebanner-4.png" id="skills">
    <div class="card-3 m-auto p-2 text-center">
      <h1 class="welcome">My Software Development Skills</h1>
      <p>
        Here are the skills that I have developed while working on exciting<br> and challenging
         projects as a software designer <br> and developer in the last 4 years.
      </p>
    </div>
  </div>
  <div class="row wow_imgage wow fadeInLeft inner-container-2 m-auto">
      <div class="col-lg-3 container-2 p-3">
        <div class="card col-md-4 col-sm-6 col-xs-12 container_foto ">
          <div class="ver_mas text-center pt-2">
             <p  class="more">4 years of experience in, Graphic design, Logo design & UI/UX</p>
          </div>
          <article class="text-left">
             <h2>Design</h2>
             <ul class="list">
              <li class="">- Photoshop</li>
              <li class="">- Illustrator</li>
              <li class="">- Adobe XD</li>
            </ul>
          </article>
          <img src="../assets/img/bg4.jpg" alt="">
       </div>
      </div>
      <div class="col-lg-3 container-2 p-3">
        <div class="card col-md-4 col-sm-6 col-xs-12 container_foto">
          <div class="ver_mas text-center pt-2">
            <p  class="more">4 years of experience building Responsive mobile-optimized Web and Hybrid Moblie applications UI/UX</p>
          </div>
          <article class="text-left">
            <h2>Front-End</h2>
            <ul class="list">
              <li class="">- HTML 5</li>
              <li class="">- CSS 3/SCSS</li>
              <li class="">- JavaScript/TypeScript</li>
              <li class="">- Angular</li>
              <li class="">- VueJs</li>
              <li class="">- Ionic</li>
              <li class="">- Bootstrap</li>
              <li class="">- WordPress</li>
            </ul>
          </article>
          <img src="../assets/img/bg3.jpg" alt="">
        </div>
      </div>
      <div class="col-lg-3 container-2 p-3">
        <div class="card col-md-4 col-sm-6 col-xs-12 container_foto">
          <div class="ver_mas text-center pt-2 p-2">
            <p  class="more">4 years of experience building server APIs and working with different DBMSs and query languages</p>
          </div>
          <article class="text-left">
            <h2>Back-End</h2>
            <ul class="list">
              <li class="">- JavaScript/TypeScript</li>
              <li class="">- NodeJS</li>
              <li class="">- Express</li>
              <li class="">- JSON</li>
              <li class="">- Java</li>
              <li class="">- PHP</li>
              <li class="">- Laravel</li>
              <li class="">- Firebase</li>
              <li class="">- MySQL</li>
              <li class="">- MongoDB</li>
            </ul>
          </article>
          <img src="../assets/img/bg2.jpg" alt="">
        </div>
      </div>
      <div class="col-lg-3 container-2 p-3">
        <div class="card col-md-4 col-sm-6 col-xs-12 container_foto">
          <div class="ver_mas text-center p-2">
            <p  class="more">4 years of experience working with Version Control & Project Management systems, and I am comfortable working in different IDEs</p>
          </div>
          <article class="text-left">
            <h2>Tools</h2>
            <ul class="list">
              <li class="">- Git</li>
              <li class="">- Bit bucket</li>
              <li class="">- Trello</li>
              <li class="">- Click Up</li>
              <li class="">- Slack</li><br>
              <li class="">- Visual Studio Code</li>
              <li class="">- Atom</li>
              <li class="">- Android Studio</li>
              <li class="">- Visual Studio</li>
              <li class="">- IntelliJ</li>
              <li class="">- Eclipse</li>
            </ul>
          </article>
          <img src="../assets/img/bg1.jpg" alt="">
        </div>
      </div>
  </div>
  <div class="row parallax" data-parallax="scroll" data-image-src="../assets/img/spacebanner-5.png" id="experience">
    <div class="card-3 m-auto p-4 text-center">
      <h1 class="welcome">My Experience</h1>
      <p>
        I have gained some valuable experience from internships. Following that, I have been taking freelance work for small<br>  businesses and individuals.
        I am currently exploring my entrepreneural skills through
        a few start-ups  <br> I am creating individually and in collaboration with other organizations<br>and 
         individuals with whom I share the same interests.
      </p>
    </div>
  </div>
</div>
<div class="row inner-container-2 m-auto">
  <div class="col-lg-4 container-2 p-3">
    <div class="company">
      <div class="card-body p-1">
        <b>Internship</b><p class="date">Apr 2018 - Jul 2018</p><h5>The Digital Academy</h5> <hr>
        <p>
          <b>Role</b><br>
          - Software Developer Intern <br>
          - Team of 6 interns <br>
          <br>
          <b>Project Description</b><br>
          An LMS for users to learn Java and Spring. <br>
          <br>
          <b>Technologies</b><br>
          - Front-end development: UI/UX using Angular 9+, HTML 5, CSS/SCSS, Bootstrap, JavaScript & TypeScript<br>
          - Back-end development: Server/API using SpringBoot, Java and MySQL.
        </p>
      </div>
   </div>
  </div>
  <div class="col-lg-4 container-2 p-3">
    <div class="company">
      <div class="card-body p-1">
        <b>Contract</b><p class="date">Oct 2018 - Dec 2018</p><h5>The Digital Academy</h5> <hr>
        <p>
          <b>Role</b><br>
          - Software Developer & Team Leader<br>
          - Team of 6 interns <br>
          <br>
          <b>Project Description</b><br>
          An online Skills Showcasing System, where employers can browse and filter through 
          various sets of skills for potential contrators or employees for their projects. <br>
          <br>
          <b>Technologies</b><br>
          - Front-end development: UI/UX using PHP, HTML 5, CSS, Bootstrap, JavaScript, jQuery<br>
          - Back-end development: Server/API using PHP, Laravel and MySQL.
        </p>
      </div>
   </div>
  </div>
  <div class="col-lg-4 container-2 p-3">
    <div class="company">
      <div class="card-body p-1">
        <b class="pull-right">Extended contract</b><p class="date">Jan 2019 - Apr 2019</p><h5>The Digital Academy</h5> <hr>
        <p>
          <b>Role</b><br>
          - Software Developer & Team Leader<br>
          - Team of 6 interns <br>
          <br>
          <b>Project Description</b><br>
          An online Showcasing room, where potential partners can browse through and demo The Digital Academy's previous work and projects. <br>
          <br>
          <b>Technologies</b><br>
          - MEAN Stack <br>
          - Bootstrap
        </p>
      </div>
   </div>
  </div>
  <div class="col-lg-4 container-2 p-3">
    <div class="company">
      <div class="card-body p-1">
        <b class="pull-right">Contract</b><p class="date">April 2021 - July 2021</p><h5>Darkhorse Accelerator</h5> <hr>
        <p>
          <b>Role</b><br>
          - Entrepreneur In Residence<br>
          <br>
          <b>Project Description</b><br>
          A services/household services marketplace for Small toMedium Businesses (SMB's). Businesses and public users can onboard on the platform and conduct business online. <br>
          <br>
          <b>Technologies</b><br>
          - MEAN Stack <br>
          - Angular Material
        </p>
      </div>
   </div>
  </div>
  <div class="col-lg-4 container-2 p-3">
    <div class="company">
      <div class="card-body p-1">
        <b class="pull-right">Contract</b><p class="date">August 2021 - January 2022</p><h5>Racvert</h5> <hr>
        <p>
          <b>Role</b><br>
          - Full-stack Developer<br>
          <br>
          <b>Job Description</b><br>
          I worked on full stack web applications using VueJs for front-end and Laravel on the server-side. <br>
          <br>
          <b>Technologies</b><br>
          - VueJs <br>
          - Laravel
        </p>
      </div>
   </div>
  </div>
  <div class="col-lg-4 container-2 p-3">
    <div class="company">
      <div class="card-body p-1">
        <b class="pull-right">Contract</b><p class="date">June 2022 - September 2022</p><h5>Mindfulskills</h5> <hr>
        <p>
          <b>Role</b><br>
          - Full-stack Developer<br>
          <br>
          <b>Job Description</b><br>
          I worked on full stack web applications using MEAN stack. I also maintained websites in WordPress. <br>
          <br>
          <b>Technologies</b><br>
          - MEAN <br>
          - WordPress
        </p>
      </div>
   </div>
  </div>
</div>

<div class="row class-2" id="contact">
  <div class="col-lg-6 container-2 m-auto p-3">
    <h1 class="text-center" style="color: #c0af00;">
      Let's collaborate.
    </h1> <br>
      <h4 class="text-center p-3" style="color: aliceblue;">
        Contact me if you have a role you would<br>
       like to discuss for your next project.
      </h4>
  </div>
  <div class="col-lg-6 container-2 form p-5">
    <h1 class="text-center">Send me an email</h1>
    <form action="">
      <div class="form-group text-center">
          <input class="form-control" name="" id="" placeholder="Provide your name...">
          <input class="form-control mt-3" name="" id="" placeholder="Provide your email...">
          <textarea class="form-control mt-3" name="" id="" placeholder="Your message..."></textarea>
          <button class="btn btn-primary mt-3 send">Submit Email</button>
      </div>
    </form>
  </div>
</div>

<div class="row class inner-container-3" id="contact">
  <!-- <div class="col-lg-12"> -->
    <div class="col-lg-4">
      <div class="address">
        <h5>Address</h5><br>
        <i class="fa fa-home"></i>&nbsp;&nbsp;6th Street No. 7 Melville <br>
        Johannesburg <br>
        2092
      </div>
    </div>
    <div class="col-lg-4">
      <div class="address">
        <h5>Contact Details</h5><br>
        <i class="fa fa-phone"></i>&nbsp;&nbsp;+27 65 517 3773 <br>
        <i class="fa fa-envelope"></i>&nbsp;&nbsp;extensiontlhareseng@gmail.com <br>
        <i class="fa fa-envelope"></i>&nbsp;&nbsp;mogomotsikoki@gmail.com
      </div>
    </div>
    <div class="col-lg-4">
      <div class="address">
        <h5>Key Duties</h5><br>
        <i class="fa fa-code"></i>&nbsp;&nbsp;Custom App Development <br>
        <i class="fa fa-window-restore"></i>&nbsp;&nbsp;Web and Mobile UI/UX Design <br>
        <i class="fa fa-user"></i>&nbsp;&nbsp;Full-stack Developer <br>

      </div>
    </div>
  <!-- </div> -->
</div>

  <p class="footer m-auto p-3 text-center">Copyright &copy; 2021 | Desined & developed by Extension. <fa-icon [icon]="faHeart"></fa-icon></p>
